"use client";

import { cn, Badge } from "@oreme/ui";
import { cva } from "class-variance-authority";
import { useAtomValue } from "jotai";
import React, { type ReactElement } from "react";
import { SitesObservatoryList } from "@/components";
import {
  observatoryListVisibilityAtom,
  filteredObservatoriesAtom,
} from "@/store/sites";
import { useTranslations } from "next-intl";

const sitesControlBottomVariants = cva(
  "absolute left-0 right-0 bottom-0 flex flex-col h-[156px] border-t bg-background",
  {
    variants: {
      active: {
        true: "translate-y-0",
        false: "translate-y-0",
      },
    },
    defaultVariants: {
      active: false,
    },
  },
);

function SitesControlBottom(): ReactElement | null {
  const t = useTranslations("sites.ControlBottom");
  const isObservatoryListVisible = useAtomValue(observatoryListVisibilityAtom);
  const filteredObservatories = useAtomValue(filteredObservatoriesAtom);
  const count = filteredObservatories.length;

  return (
    <footer
      className={cn(
        sitesControlBottomVariants({ active: isObservatoryListVisible }),
      )}
    >
      <header className="flex flex-row gap-2 items-center justify-start h-10 px-4">
        <h3>{t("title", { count: count })}</h3>
        <Badge>{count}</Badge>
      </header>
      <SitesObservatoryList />
    </footer>
  );
}

export { SitesControlBottom };
